import React from 'react';

const ShareLargeIcon = () => {
  return (
    <svg
      width='18'
      height='22'
      viewBox='0 0 18 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M5 6.89673V8.89673H2V17.8967H16V8.89673H13V6.89673H16C16.5304 6.89673 17.0391 7.10745 17.4142 7.48252C17.7893 7.85759 18 8.3663 18 8.89673V17.8967C18 18.4272 17.7893 18.9359 17.4142 19.3109C17.0391 19.686 16.5304 19.8967 16 19.8967H2C1.46957 19.8967 0.960859 19.686 0.585786 19.3109C0.210714 18.9359 0 18.4272 0 17.8967V8.89673C0 8.3663 0.210714 7.85759 0.585786 7.48252C0.960859 7.10745 1.46957 6.89673 2 6.89673H5ZM9.884 0.365733L13.243 3.72373C13.4306 3.91137 13.5361 4.16587 13.5361 4.43123C13.5361 4.6966 13.4306 4.95109 13.243 5.13873C13.0554 5.32637 12.8009 5.43179 12.5355 5.43179C12.2701 5.43179 12.0156 5.32637 11.828 5.13873L10 3.30973V12.8967C10 13.162 9.89464 13.4163 9.70711 13.6038C9.51957 13.7914 9.26522 13.8967 9 13.8967C8.73478 13.8967 8.48043 13.7914 8.29289 13.6038C8.10536 13.4163 8 13.162 8 12.8967V3.30973L6.172 5.13873C6.07909 5.23164 5.96879 5.30534 5.8474 5.35563C5.726 5.40591 5.5959 5.43179 5.4645 5.43179C5.33311 5.43179 5.203 5.40591 5.0816 5.35563C4.96021 5.30534 4.84991 5.23164 4.757 5.13873C4.66409 5.04582 4.59039 4.93552 4.54011 4.81413C4.48982 4.69274 4.46394 4.56263 4.46394 4.43123C4.46394 4.29984 4.48982 4.16973 4.54011 4.04834C4.59039 3.92694 4.66409 3.81664 4.757 3.72373L8.117 0.365733C8.35139 0.131547 8.66917 0 9.0005 0C9.33183 0 9.64961 0.131547 9.884 0.365733Z'
        fill='#3B7CF4'
      />
    </svg>
  );
};

export default ShareLargeIcon;
